import { render, staticRenderFns } from "./MRegister.vue?vue&type=template&id=89868e4e&scoped=true&"
import script from "./MRegister.vue?vue&type=script&lang=js&"
export * from "./MRegister.vue?vue&type=script&lang=js&"
import style0 from "./MRegister.vue?vue&type=style&index=0&id=89868e4e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89868e4e",
  null
  
)

component.options.__file = "MRegister.vue"
export default component.exports